import { c as _c } from "react/compiler-runtime";
import DoctorCard from "@/components/DoctorCard";
import DoctorCardSkeleton from "@/components/DoctorCardSkeleton";
import { Doctor } from "@/types/doctor";
import React from "react";
interface BookingDoctorGridProps {
  doctors: Doctor[];
  loading: boolean;
  hasMore: boolean;
  observerRef: React.RefObject<HTMLDivElement | null>;
  onBook: (doctor: Doctor) => Promise<void>;
  translations?: Record<string, string>;
}
export function BookingDoctorGrid(t0) {
  const $ = _c(21);
  const {
    doctors,
    loading,
    hasMore,
    observerRef,
    onBook,
    translations
  } = t0;
  let t1;
  if ($[0] !== doctors || $[1] !== onBook) {
    let t2;
    if ($[3] !== onBook) {
      t2 = (doctor, idx) => <DoctorCard key={doctor.id + "-" + idx} doctor={doctor} onBook={onBook} priority={idx < 3} />;
      $[3] = onBook;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = doctors.map(t2);
    $[0] = doctors;
    $[1] = onBook;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== doctors.length || $[6] !== loading) {
    t2 = loading && (() => {
      const remainder = doctors.length % 3;
      const skeletonsNeeded = remainder === 0 ? 3 : 3 - remainder;
      return Array.from({
        length: skeletonsNeeded
      }).map(_temp);
    })();
    $[5] = doctors.length;
    $[6] = loading;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-5">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      height: 1
    };
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== observerRef) {
    t5 = <div ref={observerRef} style={t4} />;
    $[12] = observerRef;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== hasMore || $[15] !== translations?.noMoreDoctors) {
    t6 = !hasMore && <div className="text-center text-[#6E6E73]/60 dark:text-[#86868B]/60 py-12 font-bold uppercase tracking-widest text-[11px]">{translations?.noMoreDoctors ?? "End of results"}</div>;
    $[14] = hasMore;
    $[15] = translations?.noMoreDoctors;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t5 || $[19] !== t6) {
    t7 = <div className="w-full">{t3}{t5}{t6}</div>;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
}
function _temp(_, idx_0) {
  return <DoctorCardSkeleton key={"skeleton-" + idx_0} />;
}